import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { UserProfileService } from '../../../shared/services/user-profile.service';
import { IRole, Roles } from '../../../shared/models/users/constants/roles';

// Extend MenuItem interface to include roles
interface CustomMenuItem extends MenuItem {
    roles?: string[];
    items?: CustomMenuItem[];
}

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul>`
})
export class AppMenu implements OnInit {
    model: CustomMenuItem[] = [];
    userRole: string | undefined;

    constructor(private userProfileService: UserProfileService) {
        this.userProfileService.currentUser$.subscribe(user => {
            this.userRole = user?.role?.uid;
            this.initializeMenu();
        });
    }

    ngOnInit() {
        this.initializeMenu();
    }

    private initializeMenu() {
        this.model = [
            {
                label: 'Home',
                items: [
                    { label: 'Home', icon: 'pi pi-fw pi-home', routerLink: ['/']},
                    { label: 'Dashboard', icon: 'pi pi-fw pi-chart-line', routerLink: ['dashboard'],
                visible: this.isChildItemVisible([Roles.USER, Roles.EMPLOYEE, Roles.ACCOUNTANT, Roles.HR, Roles.MANAGER, Roles.ADMIN]) }]
            },
            {
                label: 'Modules',
                icon: 'pi pi-fw pi-briefcase',
                routerLink: ['/modules'],
                visible: this.isChildItemVisible([Roles.EMPLOYEE, Roles.ACCOUNTANT, Roles.HR, Roles.MANAGER, Roles.ADMIN]),
                items: [
                    {
                        label: 'Requests',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/modules/requests'],
                        visible: this.isChildItemVisible([Roles.EMPLOYEE, Roles.ACCOUNTANT, Roles.HR, Roles.MANAGER, Roles.ADMIN]),

                    },
                    {
                        label: 'Contracts',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/modules/contracts'],
                        visible: this.isChildItemVisible([Roles.EMPLOYEE, Roles.ACCOUNTANT, Roles.HR, Roles.MANAGER, Roles.ADMIN]),

                    },

                     {
                        label: 'Clients',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/modules/clients'],
                        // visible: this.isChildItemVisible([Roles.STAFF ,Roles.ACCOUNTANT,Roles.HR, Roles.MANAGER, Roles.ADMIN]),
                        visible: this.isChildItemVisible([Roles.ACCOUNTANT,Roles.HR, Roles.MANAGER, Roles.ADMIN]),

                    },
                    {
                        label: 'Users',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/modules/users'],
                        visible: this.isChildItemVisible([Roles.EMPLOYEE ,Roles.ACCOUNTANT,Roles.HR, Roles.MANAGER, Roles.ADMIN]),

                    },
                    {
                        label: 'Companies',
                        icon: 'pi pi-fw pi-building',
                        routerLink: ['/modules/companies'],
                        visible: this.isChildItemVisible([ Roles.HR, Roles.MANAGER, Roles.ADMIN]),

                    },
                    {
                        label: 'Positions',
                        icon: 'pi pi-fw pi-sitemap',
                        routerLink: ['/modules/positions'],
                        visible: this.isChildItemVisible([Roles.HR, Roles.ADMIN]),
                    },
                ]
            },
            // {
            //     label: 'Pages',
            //     icon: 'pi pi-fw pi-briefcase',
            //     routerLink: ['/pages'],
            //     visible: this.isChildItemVisible([Roles.ADMIN]),
            //     items: [
            //         {
            //             label: 'Users',
            //             icon: 'pi pi-fw pi-users',
            //             routerLink: ['/pages/users'],
            //             visible: this.isChildItemVisible([Roles.ADMIN]),

            //         },
            //         {
            //             label: 'Landing',
            //             icon: 'pi pi-fw pi-globe',
            //             routerLink: ['/landing'],
            //             visible: this.isChildItemVisible([Roles.ADMIN]),

            //         },
            //         {
            //             label: 'Auth',
            //             icon: 'pi pi-fw pi-user',
            //             visible: this.isChildItemVisible([Roles.ADMIN]),
            //             items: [
            //                 {
            //                     label: 'Login',
            //                     icon: 'pi pi-fw pi-sign-in',
            //                     routerLink: ['/auth/login'],
            //                     visible: this.isChildItemVisible([Roles.ADMIN]),

            //                 },
            //                 {
            //                     label: 'Error',
            //                     icon: 'pi pi-fw pi-times-circle',
            //                     routerLink: ['/auth/error'],
            //                     visible: this.isChildItemVisible([Roles.ADMIN]),

            //                 },
            //                 {
            //                     label: 'Access Denied',
            //                     icon: 'pi pi-fw pi-lock',
            //                     routerLink: ['/auth/access'],
            //                     visible: this.isChildItemVisible([Roles.ADMIN]),

            //                 }
            //             ]
            //         },
            //         {
            //             label: 'Crud',
            //             icon: 'pi pi-fw pi-pencil',
            //             routerLink: ['/pages/crud'],
            //             visible: this.isChildItemVisible([Roles.ADMIN]),

            //         },
            //         {
            //             label: 'Not Found',
            //             icon: 'pi pi-fw pi-exclamation-circle',
            //             routerLink: ['/pages/notfound'],
            //             visible: this.isChildItemVisible([Roles.ADMIN]),

            //         },
            //         {
            //             label: 'Empty',
            //             icon: 'pi pi-fw pi-circle-off',
            //             routerLink: ['/pages/empty'],
            //             visible: this.isChildItemVisible([Roles.ADMIN]),

            //         }
            //     ]
            // },
            // {
            //     label: 'Hierarchy',
            //     visible: this.isChildItemVisible([Roles.ADMIN]),
            //     items: [
            //         {
            //             label: 'Submenu 1',
            //             icon: 'pi pi-fw pi-bookmark',
            //             items: [
            //                 {
            //                     label: 'Submenu 1.1',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [
            //                         { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
            //                         { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
            //                         { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
            //                     ]
            //                 },
            //                 {
            //                     label: 'Submenu 1.2',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
            //                 }
            //             ]
            //         },
            //         {
            //             label: 'Submenu 2',
            //             icon: 'pi pi-fw pi-bookmark',
            //             items: [
            //                 {
            //                     label: 'Submenu 2.1',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [
            //                         { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
            //                         { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
            //                     ]
            //                 },
            //                 {
            //                     label: 'Submenu 2.2',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
            //                 }
            //             ]
            //         }
            //     ]
            // },
            // {
            //     label: 'Get Started',
            //     visible: this.isChildItemVisible([Roles.ADMIN]),
            //     items: [
            //         {
            //             label: 'Documentation',
            //             icon: 'pi pi-fw pi-book',
            //             routerLink: ['/documentation'],
            //             visible: this.isChildItemVisible([Roles.ADMIN])
            //         },
            //         {
            //             label: 'View Source',
            //             icon: 'pi pi-fw pi-github',
            //             url: 'https://github.com/primefaces/sakai-ng',
            //             target: '_blank',
            //             visible: this.isChildItemVisible([Roles.ADMIN])
            //         }
            //     ]
            // },
            // {
            //     label: 'UI Components',
            //     visible: this.isChildItemVisible([Roles.ADMIN]),
            //     items: [
            //         { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'], visible: this.isChildItemVisible([Roles.ADMIN]) },
            //         { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'], visible: this.isChildItemVisible([Roles.ADMIN]) },
            //         { label: 'Button', icon: 'pi pi-fw pi-mobile', class: 'rotated-icon', routerLink: ['/uikit/button'], visible: this.isChildItemVisible([Roles.ADMIN]) },
            //         { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'], visible: this.isChildItemVisible([Roles.ADMIN]) },
            //         { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'], visible: this.isChildItemVisible([Roles.ADMIN]) },
            //         { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'], visible: this.isChildItemVisible([Roles.ADMIN]) },
            //         { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'], roles: [Roles.ADMIN] },
            //         { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'], roles: [Roles.ADMIN] },
            //         { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'], roles: [Roles.ADMIN] },
            //         { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'], roles: [Roles.ADMIN] },
            //         { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'], roles: [Roles.ADMIN] },
            //         { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'], roles: [Roles.ADMIN] },
            //         { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'], roles: [Roles.ADMIN] },
            //         { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'], roles: [Roles.ADMIN] },
            //         { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'], roles: [Roles.ADMIN] }
            //     ]
            // },
        ];
    }

    isMenuItemVisible(item: CustomMenuItem): boolean {
        if (!item.roles) {
            return true; // If no roles specified, show to everyone
        }

        if (!this.userRole) {
            return false; // If no user role, don't show restricted items
        }

        // Check if the user's role is in the allowed roles for this menu item
        return item.roles.includes(this.userRole);
    }

    isChildItemVisible(roles: string[]): boolean {
        if (!roles) {
            return true; // If no roles specified, show to everyone
        }

        if (!this.userRole) {
            return false; // If no user role, don't show restricted items
        }

        // Check if the user's role is in the allowed roles for this menu item
        return roles.includes(this.userRole);
    }
}
